<template>
  <div class="message-dialogue" :class="{ backdrop: backdrop }">
    <div class="dialogue-window" :appearance="compAppearance">
      <div class="banner">
        <div class="circles">
          <div class="circle-container circle1"><div class="circle" /></div>
          <div class="circle-container circle2"><div class="circle" /></div>
          <div class="circle-container circle3"><div class="circle" /></div>
        </div>
        <img class="heart" :src="heart" alt="" />
      </div>

      <h1 class="title">Sorry, We Are Full.</h1>

      <ul class="error-list">
        <li class="error">
          {{ message }}
        </li>
      </ul>

      <button type="button" class="ok-button" @click="close">OK</button>
    </div>
  </div>
</template>

<script>
import heart from '@/assets/img/messages/glow_heart.png';

export default {
  name: 'message-dialogue',

  data() {
    return {
      heart,
      message:
        "We're sorry, but we have reached the maximum participants for this course. Please subscribe to our monthly newsletter to hear more about upcoming guest experts and courses.",
    };
  },

  props: {
    backdrop: {
      type: Boolean,
      default: true,
    },
    appearance: {
      type: Object,
      default: () => ({ w: 80, h: 70 }),
    },
  },

  computed: {
    compAppearance() {
      const height = this.appearance.h || 70;
      const width = this.appearance.w || 80;

      return { h: height, w: width };
    },
  },

  methods: {
    close() {
      this.$store.dispatch('clearRegistrationFull');
    },
  },
};
</script>

<style scoped>
.message-dialogue {
  position: fixed;
  top: 0%;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
}

.backdrop {
  background-color: rgba(0, 0, 0, 0.6);
}

.dialogue-window {
  position: relative;
  width: 556px;
  max-width: 80%;
  max-height: 90%;

  border-radius: 0.8em;
  overflow: hidden;

  font-size: 18px;
  text-align: center;
  color: #5c5c5c;

  background: #edf3fd;
}

.banner {
  position: relative;
  width: 100%;
  height: 221px;

  background-image: linear-gradient(234deg, #7a65ff 25%, #46afff 78%, #45b0ff 100%);
  border-radius: 8px 8px 0px 0px;

  perspective: 900px;
}

.banner > .heart {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 80%;
}

.banner > .circles {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  height: 200px;
  width: 200px;
}

.circle-container {
  position: absolute;
  width: 100%;
  height: 100%;

  transform-origin: center center;
}

.circle1 {
  transform: rotate(45deg) rotate3d(0, 1, 0, 75deg);
}
.circle1 > .circle {
  border-right: 2px solid #e6ffe6;
}
.circle2 {
  transform: rotate(90deg) rotate3d(0, 1, 0, 75deg);
}
.circle2 > .circle {
  border-bottom: 2px solid #e6ffe6;
}
.circle3 {
  transform: rotate(135deg) rotate3d(0, 1, 0, 75deg);
}
.circle3 > .circle {
  border-left: 2px solid #e6ffe6;
}

.circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transform-origin: center center;
  animation: 9s linear 0s infinite normal forwards running spin;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

h1.title {
  font-size: 2em;
  color: inherit;
}

.error-list > li {
  margin: 1em 3em;
}

.error-code {
  color: red;
}

.ok-button {
  display: block;
  height: 2em;
  width: 10em;
  margin: 2em auto 2em auto;

  cursor: pointer;

  font-size: 21px;
  color: #ffffff;
  text-align: center;

  background-image: linear-gradient(224deg, #7a65ff 43%, #45b0ff 100%);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  border: none;
}
</style>
